import React from 'react';

interface RootDashboardPageProps {
  onLogout: () => void;
  onNavigate: (page: string) => void;
}

const RootDashboard: React.FC<RootDashboardPageProps> = ({ onLogout, onNavigate }) => {
  return (
    <div className="min-h-screen bg-gray-50 p-5">
      <div className="max-w-6xl mx-auto">
        <div className="bg-white rounded-xl shadow-lg overflow-hidden">
          <div className="p-8 text-white flex justify-between items-center" style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
            <div>
              <h1 className="text-3xl font-bold mb-2">👑 Pannello Root</h1>
              <p className="opacity-90">Accesso completo a tutte le funzionalità</p>
            </div>
            <button
              onClick={onLogout}
              className="px-4 py-2 bg-white bg-opacity-20 hover:bg-opacity-30 rounded-lg transition-all"
            >
              🚪 Esci
            </button>
          </div>

          <div className="p-8">
            <h2 className="text-xl font-semibold mb-4 text-gray-700">⚙️ Configurazione Sistema</h2>
            <div className="grid md:grid-cols-2 gap-6 mb-8">
              <button
                onClick={() => onNavigate('operatori')}
                className="p-8 bg-gradient-to-br from-blue-50 to-blue-100 border-2 border-blue-400 rounded-xl hover:shadow-lg transition-all group"
              >
                <div className="text-6xl mb-4 group-hover:scale-110 transition-transform">👥</div>
                <h3 className="text-2xl font-bold text-blue-900 mb-2">Gestione Operatori</h3>
                <p className="text-blue-700">Inserisci e modifica gli operatori del sistema</p>
              </button>

              <button
                onClick={() => onNavigate('strutture')}
                className="p-8 bg-gradient-to-br from-purple-50 to-purple-100 border-2 border-purple-400 rounded-xl hover:shadow-lg transition-all group"
              >
                <div className="text-6xl mb-4 group-hover:scale-110 transition-transform">🏢</div>
                <h3 className="text-2xl font-bold text-purple-900 mb-2">Gestione Strutture</h3>
                <p className="text-purple-700">Inserisci e modifica le strutture</p>
              </button>
            </div>

            <h2 className="text-xl font-semibold mb-4 text-gray-700">📊 Gestione e Monitoraggio</h2>
            <div className="grid md:grid-cols-2 gap-6">
              <button
                onClick={() => onNavigate('timesheet')}
                className="p-8 bg-gradient-to-br from-green-50 to-green-100 border-2 border-green-400 rounded-xl hover:shadow-lg transition-all group"
              >
                <div className="text-6xl mb-4 group-hover:scale-110 transition-transform">⏰</div>
                <h3 className="text-2xl font-bold text-green-900 mb-2">Timesheet Personale</h3>
                <p className="text-green-700">Registra le tue ore di lavoro</p>
              </button>

              <button
                onClick={() => onNavigate('admin')}
                className="p-8 bg-gradient-to-br from-orange-50 to-orange-100 border-2 border-orange-400 rounded-xl hover:shadow-lg transition-all group"
              >
                <div className="text-6xl mb-4 group-hover:scale-110 transition-transform">🛠️</div>
                <h3 className="text-2xl font-bold text-orange-900 mb-2">Amministrazione</h3>
                <p className="text-orange-700">Statistiche ed esportazioni dati</p>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RootDashboard;